"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleError = void 0;
const handleError = (err, handlers) => {
    var _a;
    // Double check the right error has been given here, {@code err} is unlikely to be typed
    // when given as parameter due to the nature of "try catch"
    const isAxiosError = err === null || err === void 0 ? void 0 : err.isAxiosError;
    // Check to see if we have a status
    const status = isAxiosError && ((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status);
    // Try to get a handler
    const handler = status && handlers[status];
    if (!handler) {
        throw err;
    }
    return handler(err);
};
exports.handleError = handleError;
//# sourceMappingURL=error.js.map